export const getOptionalFieldLabel = (fieldLabel, text) => {
    return `${fieldLabel} (${text('FORM_OPTIONAL_FIELD_LABEL')})`;
};
